import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${API_URL}/api`;

// Inquiry API
export const submitInquiry = async (inquiryData) => {
  try {
    const response = await axios.post(`${API}/inquiries`, inquiryData);
    return response.data;
  } catch (error) {
    console.error('Error submitting inquiry:', error);
    throw error;
  }
};

export const getInquiries = async (status = null) => {
  try {
    const url = status ? `${API}/inquiries?status=${status}` : `${API}/inquiries`;
    const response = await axios.get(url);
    return response.data;
  } catch (error) {
    console.error('Error fetching inquiries:', error);
    throw error;
  }
};

// Events API
export const getEvents = async () => {
  try {
    const response = await axios.get(`${API}/events`);
    return response.data;
  } catch (error) {
    console.error('Error fetching events:', error);
    throw error;
  }
};

export const createEvent = async (eventData) => {
  try {
    const response = await axios.post(`${API}/events`, eventData);
    return response.data;
  } catch (error) {
    console.error('Error creating event:', error);
    throw error;
  }
};

export const deleteEvent = async (eventId) => {
  try {
    const response = await axios.delete(`${API}/events/${eventId}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting event:', error);
    throw error;
  }
};

export const markEventInterested = async (eventId) => {
  try {
    const response = await axios.post(`${API}/events/${eventId}/interest`);
    return response.data;
  } catch (error) {
    console.error('Error marking interest:', error);
    throw error;
  }
};
